import React from 'react'

import {
  HOMEPAGE_FIELDS,
  LOCAL_BUSINESS_FIELDS,
  SLIDE_FIELDS,
} from '../../constants/fieldGroups.constant'
import AbstractDocument from '../Abstract/AbstractDocument'

const Project = function () {
  return (
    <AbstractDocument
      singleCollectionName="Project"
      notToShow={[
        'ancestorIds',
        'parentId',
        'type',
        ...SLIDE_FIELDS,
        ...HOMEPAGE_FIELDS,
        ...LOCAL_BUSINESS_FIELDS,
      ]}
    />
  )
}
export default Project
